'use client'

import dynamic from 'next/dynamic'
import { useEffect, useRef } from 'react'

import usePx from '@src/quince-site-common/src/hooks/usePx'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

function QRCanvasComponent({ url, widthInRem }: { url: string; widthInRem: number }) {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const getPxFromRem = usePx()
  const widthInPx = getPxFromRem(widthInRem, false)

  useEffect(() => {
    const generateQR = async () => {
      if (canvasRef.current) {
        const { toCanvas } = await import('qrcode')
        try {
          await toCanvas(canvasRef.current, url, {
            width: widthInPx,
          })
          trackEvent(TELEMETRY_EVENT_NAMES.QR_RENDERED_SUCCESS, {})
        } catch {
          trackEvent(TELEMETRY_EVENT_NAMES.QR_RENDERED_ERROR, {})
        }
      }
    }
    void generateQR()
  }, [url, widthInPx])

  return <canvas ref={canvasRef} width={widthInPx} height={widthInPx} />
}

export default dynamic(() => Promise.resolve(QRCanvasComponent), {
  ssr: false,
})
